import global from "../global.js"
export default {
    data(){
        return{
            customer_list: []
        }
    },
    methods: {
        async getCrmCustomers(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/crm/customers/list_view', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async shadowEmployees(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/crm/shadow_employees/search', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getProductsPurchasedAndNotPurchased(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.get(global.CRM_API + '/company/get_products_purchased_not_purchased', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getCustomerDetails(customer_id) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(global.CRM_API + "/customers/get?id=" + customer_id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getCustomerForTickets(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/crm/get_customers_for_tickets",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getCustomerForTicketsFilter(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/filters/get_customers",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getCompanyForTickets(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/crm/get_companies_for_tickets",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getCompanyForTicketsFilter(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/filters/get_companies",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getBranchsForTickets(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/crm/get_branches_for_tickets",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getBranchsForTicketsFilter(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("filters/get_branches",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getDepartments(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/department/list_view",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getBranches(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post('/crm/get_branches_for_customer',params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
        async getDepartmentsFilter(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post("/filters/get_departments",params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                }
            })
        },
    }
}        